import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

function getSavedState(params) {
  const state = {};
  // eslint-disable-next-line
  for (const param in params) {
    try {
      state[param] = JSON.parse(localStorage.getItem(param)) || params[param];
    } catch {
      // eslint-disable-no-empty
    }
  }
  return state;
}

function saveState(param, value) {
  localStorage.setItem(param, JSON.stringify(value));
}

export default new Vuex.Store({
  state: {
    ...getSavedState({
      token: '',
      email: '',
      name: '',
      userId: '',
      rights: {
        edit: false,
        delete: false,
        meta: false,
      },
      columnsSettings: [],
    }),
    entities: {},
    entityTrigger: false,
    currentEntity: '',
    isRowModalVisible: false,
    rowModalId: null,
  },
  mutations: {
    setToken(state, payload) {
      saveState('token', payload);
      state.token = payload;
    },
    setEmail(state, payload) {
      saveState('email', payload);
      state.email = payload;
    },
    setName(state, payload) {
      saveState('name', payload);
      state.name = payload;
    },
    setRights(state, payload) {
      state.rights.edit = payload.indexOf('edit_entities') !== -1;
      state.rights.delete = payload.indexOf('delete_entities') !== -1;
      state.rights.meta = payload.indexOf('edit_metadata') !== -1;
      saveState('rights', state.rights);
    },
    setEntities(state, payload) {
      state.entities = payload;
    },
    setRawColumnsSettings(state, payload) {
      try {
        const settings = JSON.parse(payload);
        state.columnsSettings = settings;
        saveState('columnsSettings', settings);
      } catch {
        // eslint-disable-no-empty
      }
    },
    setColumnsSettings(state, payload) {
      const obj = state.columnsSettings.find(v => v.entity === payload.entity);
      if (obj) {
        obj.hidden = payload.hidden;
        obj.sorted = payload.sorted;
      } else {
        state.columnsSettings.push(payload);
      }
      saveState('columnsSettings', state.columnsSettings);

      if (!state.userId) {
        return;
      }
      Vue.prototype.$api.editEntity({
        name: 'user',
        id: state.userId,
        params: { tables_state: JSON.stringify(state.columnsSettings) },
      }).then(() => {
        if (state.currentEntity === 'user') {
          state.entityTrigger = !state.entityTrigger;
        }
      });
    },
    setCurrentEntity(state, payload) {
      state.currentEntity = payload;
    },
    updateEntityContent(state) {
      state.entityTrigger = !state.entityTrigger;
    },
    setIsRowModalVisible(state, payload) {
      state.isRowModalVisible = payload;
    },
    setRowModalId(state, payload) {
      state.rowModalId = payload;
    },
    setUserId(state, payload) {
      saveState('userId', payload);
      state.userId = payload;
    },
  },
  getters: {
    userId: state => state.userId,
    token: state => state.token,
    email: state => state.email,
    name: state => state.name,
    rights: state => state.rights,
    entities: state => state.entities,
    columnsSettings: state => state.columnsSettings,
    currentEntity: state => state.currentEntity,
    entityTrigger: state => state.entityTrigger,
    isRowModalVisible: state => state.isRowModalVisible,
    rowModalId: state => state.rowModalId,
  },
});
